import { render } from "./LicenzaBanner.vue?vue&type=template&id=6897355c&scoped=true"
import script from "./LicenzaBanner.vue?vue&type=script&lang=js"
export * from "./LicenzaBanner.vue?vue&type=script&lang=js"

import "./LicenzaBanner.vue?vue&type=style&index=0&id=6897355c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6897355c"]])

export default __exports__